import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWater = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 5.19209C11.2902 6.60542 10.2843 8.67307 9.45316 10.6285C9.03101 11.6217 8.66022 12.5714 8.39667 13.3836C8.1231 14.2267 8 14.8196 8 15.1428C8 17.246 9.76334 19 12 19C14.2367 19 16 17.246 16 15.1428C16 14.8196 15.8769 14.2267 15.6033 13.3836C15.3398 12.5714 14.969 11.6217 14.5468 10.6285C13.7157 8.67307 12.7098 6.60542 12 5.19209ZM10.2449 4.23047C10.9752 2.77849 13.0248 2.77848 13.7551 4.23047C14.4739 5.65963 15.5194 7.80375 16.3875 9.84616C16.8211 10.8665 17.2168 11.876 17.5057 12.7663C17.7846 13.6259 18 14.4789 18 15.1428C18 18.4048 15.2862 21 12 21C8.71381 21 6 18.4048 6 15.1428C6 14.4789 6.21542 13.6259 6.49431 12.7663C6.78323 11.876 7.17886 10.8665 7.61251 9.84617C8.48059 7.80376 9.52613 5.65963 10.2449 4.23047Z",
		fill: "currentColor"
	})
});
export default SvgWater;
